export const handleSpecsDownload = (e, title, link, productInfo = null) => {
  e.stopPropagation()
  let errMsg
  const url = link.trim()
  try {
    window.open(url, "_blank")
  } catch (err) {
    errMsg = err.message
  }

  const kohlerDatalayer = window.kohler.datalayer
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    eventMetaData: {
      experience: "pdp",
      eventType: "eventInfoProdAccordion",
      params: {
        type: title,
        tabName: "specs",
        needsJSON: true,
        link: url,
        errMsg: errMsg,
      },
    },
  })
}
